
export function ErrorHandler(_error) {
    console.warn(_error);
}
